module.exports = __webpack_public_path__ + "media/images/earth-dark-fba5551b3f8ea655e43b6fc7fa42a15e.jpg";